import API from 'files/api.js';

const buildRequest = (url, props) => {
    let newURL = `${url}?type=${props.type}`;
    for(var i in props) {
        if(i == 'type') {
            continue;
        }
        newURL += `&${i}=${typeof(props[i]) === 'object' ? JSON.stringify(props[i]) : encodeURIComponent(props[i])}`;
    }
    return newURL;
}

const get = async (utils, url, props, options) => {
    return new Promise(async (resolve, reject) => {
        try {

            // prepare fetch options and fetch request
            let { server, signal } = options || {};
            let response = await fetch(buildRequest(server ? `${server}${url}` : `${API.url}${url}`, props), {
                headers: utils.api.headers(),
                method: 'GET',
                signal: signal,
                credentials: 'include',
            });

            // determine if response code represents a 5xx level error
            if([502, 503, 504].includes(response.status)) {
                throw new Error('Please try again in a few minutes');
            }

            // prevent moving forward if an error was thrown
            if(response.status !== 200) {
                let text = await response.text();
                throw new Error(text || 'An unknown error occurred');
            }

            let json = await response.json();
            resolve(json);

        } catch(e) {
            reject(e);
        }
    })
}

const post = async (utils, url, props, server) => {
    return new Promise(async (resolve, reject) => {
        try {

            let response = await fetch(server ? `${server}${url}` : `${API.url}${url}`, {
                method: 'POST',
                credentials: 'include',
                headers: utils.api.headers(),
                body: JSON.stringify(props)
            });

            // determine if response code represents a 5xx level error
            if([502, 503, 504].includes(response.status)) {
                throw new Error('Please try again in a few minutes');
            }

            // prevent moving forward if an error was thrown
            if(response.status !== 200) {
                let text = await response.text();
                throw new Error(text || 'An unknown error occurred');
            }

            let json = await response.json();
            resolve(json);

        } catch(e) {
            reject(e);
        }
    })
}

const Request = {
    get: get,
    post: post
}
export default Request;
